import { render } from "./LiquidationHistory.vue?vue&type=template&id=62b41e86"
import script from "./LiquidationHistory.vue?vue&type=script&lang=js"
export * from "./LiquidationHistory.vue?vue&type=script&lang=js"

import "./LiquidationHistory.vue?vue&type=style&index=0&id=62b41e86&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__